import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateWriteoffDetailAction as updateWriteoffDetail } from '../../../../../services/WriteoffService/slice';

export const WriteoffReasonField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentWriteoff } = useAppSelector(state => state.writeoff);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateWriteoffDetail({ reason: event.target.value }));
  };

  return (
    <TextField
      label="Reason"
      value={currentWriteoff?.detail?.reason || ''}
      onChange={handleChange}
      size="small"
      fullWidth
      sx={{ flex: 2 }}
      placeholder="Enter writeoff reason"
    />
  );
};

export default WriteoffReasonField;
